/**
 * Sales channels section: two Tween count-ups on scroll (matches Corporate Information introduce page #test2 / num2 / num3).
 */
(function () {
  function setAnimatedNum(newValue, oldValue, el) {
    function animate(time) {
      requestAnimationFrame(animate);
      TWEEN.update(time);
    }
    new TWEEN.Tween({ tweeningNumber: oldValue })
      .easing(TWEEN.Easing.Quadratic.Out)
      .to({ tweeningNumber: newValue }, 1000)
      .onUpdate(function () {
        el.textContent = this.tweeningNumber.toFixed(0);
      })
      .start();
    animate();
  }

  function initSection(root) {
    if (root.getAttribute('data-sales-channels-initialized') === '1') return;
    var sid = root.getAttribute('data-sales-channels-section');
    if (!sid || typeof TWEEN === 'undefined') return;

    var testEl = document.getElementById('test2-' + sid);
    var num2 = document.getElementById('num2-' + sid);
    var num2Show = document.getElementById('num2Show-' + sid);
    var num3 = document.getElementById('num3-' + sid);
    var num3Show = document.getElementById('num3Show-' + sid);
    if (!testEl || !num2 || !num2Show || !num3 || !num3Show) return;

    root.setAttribute('data-sales-channels-initialized', '1');

    function handleScroll() {
      var docScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var clientH = window.innerHeight;
      var rect = testEl.getBoundingClientRect();
      var sectionTop2 = rect.top + docScrollTop;
      var sectionH2 = testEl.offsetHeight;

      if (
        docScrollTop + clientH - sectionTop2 >= 0 &&
        docScrollTop - sectionTop2 - sectionH2 <= 0
      ) {
        var t2 = parseInt(num2.textContent, 10);
        var s2 = parseInt(num2Show.textContent, 10);
        if (t2 !== s2) {
          setAnimatedNum(t2, s2, num2Show);
        }
        var t3 = parseInt(num3.textContent, 10);
        var s3 = parseInt(num3Show.textContent, 10);
        if (t3 !== s3) {
          setAnimatedNum(t3, s3, num3Show);
        }
      }
    }

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  function run() {
    document.querySelectorAll('[data-sales-channels-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
